import noUiSlider from 'nouislider';

export default function() {
  return {
    slider: null,
    input: null,
    init(el) {
      this.slider = el;
      const input = el.parentElement.querySelector('.js-calculator-input');
      this.input = input;

      noUiSlider.create(this.slider, {
        start: parseFloat(this.slider.dataset.start),
        connect: 'lower',
        step: parseFloat(this.slider.dataset.step),
        range: {
          min: parseFloat(this.slider.dataset.min),
          max: parseFloat(this.slider.dataset.max)
        }
      });

      el.noUiSlider.on('update', (values, handle) => {
        input.value =
          input.dataset.formating === 'int'
            ? parseInt(values[handle], 10)
            : parseFloat(values[handle]);
      });

      input.addEventListener('keyup', e => {
        if (e.target.value && parseFloat(e.target.value) !== 0)
          el.noUiSlider.set(parseFloat(e.target.value));
      });
      input.addEventListener('change', e => {
        if (e.target.value && parseFloat(e.target.value) !== 0)
          el.noUiSlider.set(parseFloat(e.target.value));
      });

      return this;
    },
    onChange(callback) {
      this.slider.noUiSlider.on('update', values => {
        callback(values);
      });
    }
  };
}
